export default "__VITE_ASSET__kMRGOCx3__";